"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFunctionConditionSchema = void 0;
const zod_1 = require("zod");
const FunctionReferenceCondition_1 = require("./FunctionReferenceCondition");
const IExternalComponentCondition_1 = require("./IExternalComponentCondition");
const IModeCondition_1 = require("../DesignModels/IModeCondition");
exports.IFunctionConditionSchema = zod_1.z.lazy(() => zod_1.z.union([IModeCondition_1.IModeConditionSchema, FunctionReferenceCondition_1.FunctionReferenceConditionSchema, IExternalComponentCondition_1.IExternalComponentConditionSchema]));
//# sourceMappingURL=IFunctionCondition.js.map